import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  HouseDoor,
  People,
  Clipboard,
  Folder,
  ChatDots,
  Calendar,
  Envelope,
  Table,
  Layers,
  Folder2Open,
} from "react-bootstrap-icons";
import "../css/Sidebar.css";
import logo from "../img/ff.png";

const Sidebar = () => {
  const location = useLocation();

  const menuItems = [
    { path: "/dashboard", label: "Dashboard", icon: <HouseDoor /> },
    { path: "/studentdetails", label: "Student Details", icon: <People /> },
    { path: "/staff", label: "Staff Details", icon: <People /> },
    { path: "/trades", label: "Trade Management", icon: <Clipboard /> },
    { path: "/ProjectUpload", label: "Project", icon: <Folder /> },
    { path: "/BonafideCertificate", label: "Bonafide", icon: <Folder /> },
    { path: "/LetterheadDocuments", label: "Letterhead-Docs", icon: <Folder2Open /> },
    { path: "/FeeDetails", label: "Fee details", icon: <Layers /> },
    { path: "/StudentNotifications", label: "Student Notifications", icon: <Calendar /> },
    { path: "/ContactMessages", label: "Contact Msg", icon: <Envelope /> },
      

    // { path: "/table", label: "Table", icon: <Table /> },
    // { path: "/components", label: "Components", icon: <Layers /> },
  ];

  const isActive = (path) => {
    // mark active when exact path or nested route (e.g. /trades/123)
    if (!path) return false;
    if (location.pathname === path) return true;
    return location.pathname.startsWith(path + "/");
  };

  return (
    <div className="sidebar d-flex flex-column p-3">
      <div className="text-center mb-4">
        <div className="d-flex align-items-center gap-3 justify-content-center">
          <img src={logo} alt="Auxilium Logo" className="header-logo" />
          <h5 className="m-0 fw-semibold text-primary">Auxilium ITI</h5>
        </div>
      </div>

      <ul className="nav nav-pills flex-column mb-auto">
        {menuItems.map((item, index) => (
          <li key={index} className="nav-item">
            <Link
              to={item.path}
              className={`nav-link d-flex align-items-center ${
                isActive(item.path) ? "active" : ""
              }`}
              aria-current={isActive(item.path) ? "page" : undefined}
            >
              <span className="me-2" aria-hidden="true">
                {item.icon}
              </span>
              <span>{item.label}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
